import styled from 'styled-components';

export const TagLabel = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  background-color: #f0f0f0;
  font-size: 12px;
  padding: 5px;
  color: #4d4d4d;
  border-radius: 5px;
`;

export const Overlay = styled.div`
  height: 100000rem;
  width: 100vw;
  position: absolute;
  background: gray;
  z-index: 10;
  opacity: 70%;
`;


export const BoostModal = styled.div`
  width: 33rem;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 1.5rem;
  z-index: 101;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  flex-direction: column;
  display: flex;
  align-items: center; 
  .close_button {
    width: 90%;
    height: 5%;
    font-size: 2rem;
    margin-top: 2rem;
    i {
      float: right;
      cursor: pointer;
    }
  }
`;

export const BoostTitle = styled.div`
  margin-top: 2rem;
  font-size: 1.8rem;
  width: 80%;
`;

export const BoostSubtitle = styled.div`
  margin-top: 1rem;
  font-size: 1.2rem;
  width: 80%;
`;

export const BoostNextButton = styled.div`
  color: white;
  margin-top: 2rem;
  text-align: center;
  font-size: 1.2rem;
  width: 7rem;
  padding: 0.8rem;
  cursor: pointer;
  border-radius: 2rem;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  font-weight: bold;
  background: ${props => (props.cont ? '#2680EB' : 'gray')};
  margin-bottom: 2rem;
`;

export const BoostInputText = styled.input`
  margin: 2rem;
  height: 6rem;
  width: 85%;
  border: none;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  border-radius: 1rem;
  outline: none;
  padding: 1rem;
  font-size: 1.4rem;
  color: #2680EB;
`;

export const BoostUrgency = styled.div`
  margin: 1rem;
  display: flex;
  width: 85%;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
`;

export const BoostUrgencyTime = styled.div`
  border: 0.1rem solid black;
  border-radius: 1rem;
  padding: 1rem;
  font-size: 1.1rem;
  margin: 0.4rem;
  color: ${props => (props.sel ? 'white' : 'black')};
  background: ${props => (props.sel ? '#2680EB' : '')};
`;



// WEBPACK FOOTER //
// ./src/components/Boost/components/styles.js